/**
 * src/components/V5Topbar.jsx
 *
 * Lime marquee topbar, matches praesidio-care-v5(1).html lines 545–562.
 * Renders ABOVE <nav> (nav has top:36px to sit below this bar).
 * Items duplicated for seamless CSS infinite scroll loop.
 */

const ITEMS = [
  'Idea to shipped product in 4 weeks',
  'The proof-of-concept company',
  '99.95% uptime SLA · SOC 2 Ready',
  'Serving EU, US, Asian, African & American clients',
  '$5K pilot → enterprise scale',
];

export default function V5Topbar() {
  const all = [...ITEMS, ...ITEMS];

  return (
    <div className="topbar">
      <div className="topbar-track">
        {all.map((item, i) => (
          <span key={i} className="topbar-item">
            {item}
            <span className="tb-sep" />
          </span>
        ))}
      </div>
    </div>
  );
}

